// Import model
import { UrlFieldOptions } from '../models/UrlFieldOptions';

// Import base class serializer
import { FieldOptionsSerializer } from './FieldOptionsSerializer';

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UrlFieldOptions - handles JSON serialization and deserialization with type validation
 */
export class UrlFieldOptionsSerializer {
  /**
   * Deserializes a JSON string into a UrlFieldOptions instance
   */
  static deserialize(json: string): UrlFieldOptions {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UrlFieldOptions instance
   */
  static fromObject(obj: any): UrlFieldOptions {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UrlFieldOptions');
    }


    const instance: UrlFieldOptions = {
      t: obj['_t'] as string,
      linkUrl: obj['LinkUrl'] as string | undefined,
      linkLabel: obj['LinkLabel'] as string | undefined,
      _9C744144: obj['_9c744144'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UrlFieldOptions instances
   */
  static deserializeArray(json: string): UrlFieldOptions[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UrlFieldOptions instance to a JSON string
   */
  static serialize(instance: UrlFieldOptions): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UrlFieldOptions instance to a plain object
   */
  static toObject(instance: UrlFieldOptions): any {
    return {
      '_t': instance.t,
      'LinkUrl': instance.linkUrl,
      'LinkLabel': instance.linkLabel,
      '_9c744144': instance._9C744144,
    };
  }

  /**
   * Serializes an array of UrlFieldOptions instances to a JSON string
   */
  static serializeArray(instances: UrlFieldOptions[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
